import React, { useMemo } from 'react';
import { DayNote } from '@features/whereabouts/services/WeekNotesService';
import { BodySmall } from "@shared/ui/atoms/fonts/Body";
import { MovementDay } from '@features/whereabouts/models/movements.models';
import { useSelector } from "react-redux";
import { selectAllWhereaboutsOptions } from '@features/whereabouts/store/whereaboutsOptions.duck';
import { findWhereaboutsOptionById } from '@shared/utils/WhereaboutsHelper';
import moment from "moment";

export function UsersDayNotesForTheWeek(props: Props) {
  const {dayNotes, whereabouts} = props;
  const whereaboutsOptions = useSelector(selectAllWhereaboutsOptions);

  const title = (dayNote: DayNote) => {
    const whereaboutsDay = whereabouts.find(w => w.date === dayNote.date);
    if (whereaboutsDay) {
      const am = findWhereaboutsOptionById(whereaboutsOptions, whereaboutsDay.amStatusId)?.label ?? 'none';
      const pm = findWhereaboutsOptionById(whereaboutsOptions, whereaboutsDay.pmStatusId)?.label ?? 'none';
      const status = am === pm ? am : `${am} | ${pm}`;
      return `${moment(dayNote.date).format('ddd')} - ${status}`
    }
  }

  const filteredDayNotes = useMemo(() => {
    return dayNotes.filter((dayNote: DayNote) => !!dayNote.note)
  }, [dayNotes])

  return (
    <>
      {filteredDayNotes.map((dayNote: DayNote, key: number) => (<React.Fragment key={key}>
        <BodySmall weight={600}>{title(dayNote)}</BodySmall>
        <BodySmall style={{marginBottom: 2}}>{dayNote.note}</BodySmall>
      </React.Fragment>))}
    </>
  )
}

interface Props {
  dayNotes: DayNote[];
  whereabouts: MovementDay[];
}
